<template>

<div class="glossary">

	<com-head />

	<div class="glossary-content outer">

		<div class="inner">

			<h1>Glossary</h1>

			<div class="glossary-terms">

				<div class="glossary-term" v-for="term in terms" :key="term.id">

					<div class="glossary-term-name">{{ term.name }}</div>

					<div class="glossary-term-definition" v-html="term.definition"></div>

				</div>

			</div>

			<div class="glossary-back">

				<button class="glossary-back-button" v-on:click="$router.push({ name: 'Home' })">
					<i class="fa-solid fa-arrow-left"></i> Back to home
				</button>

			</div>

		</div>

	</div>

</div>

</template>

<script>

import comHead from './common/Head'

export default {

	components: {
		'com-head': comHead
	},

	computed: {

		terms: function() {

			return this.$store.getters['data/glossary'] || []

		}

	}

}

</script>

<style scoped>

.glossary { height: 100%; overflow: auto; }

.glossary-content {
	padding: 60px 0;
}

.is-mobile .glossary-content { padding: 30px 0; }

.glossary-content .inner {
	max-width: 800px;
	padding: 0 40px;
}

.is-mobile .glossary-content .inner { padding: 0 15px; }

.glossary-content h1 {
	color: #343434;
	font-size: 36px;
	font-weight: 100;
	letter-spacing: 3px;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.glossary-content h1:after {
	content: ' ';
	display: block;
	position: absolute;
	width: 100px;
	height: 4px;
	background-color: var(--primary-color);
	left: 0px;
	bottom: -20px;
}

.is-mobile .glossary-content h1 { font-size: 24px; margin-bottom: 32px; }

.glossary-terms { margin-bottom: 48px; }

.glossary-term {
	padding: 20px 0;
	border-bottom: 1px solid #e0e0e0;
}

.glossary-term:first-child { border-top: 1px solid #e0e0e0; }

.glossary-term-name {
	font-size: 18px;
	font-weight: 700;
	color: #343434;
	margin-bottom: 8px;
}

.is-mobile .glossary-term-name { font-size: 16px; }

.glossary-term-definition {
	font-size: 16px;
	color: #343434;
	line-height: 26px;
	font-weight: 300;
}

.is-mobile .glossary-term-definition { font-size: 14px; line-height: 22px; }

.glossary-back-button {
	padding: 12px 32px;
	border-radius: 32px;
	font-size: 14px;
	font-weight: 600;
	background-color: transparent;
	color: #343434;
	border: 2px solid #ddd;
	cursor: pointer;
	transition: all 300ms ease-in-out;
}

.glossary-back-button:hover { border-color: #343434; }

.glossary-back-button i { margin-right: 8px; }

</style>
